import Stepper from './Stepper';
import Step from './Step';

Stepper.Step = Step;

export { Step };

export default Stepper;
